export enum TemperatureUnit {
  Fahrenheit = 'F',
  Celsius = 'C',
}
